module.exports = {
  middle: 990,
  wide: 1280,
}
